export default __webpack_public_path__ + "static/media/icon-route-map.2cddad16.svg";